import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { Card, Checkbox, Divider } from 'semantic-ui-react';
import PendingInvitation from '../pending-invitation';
import { EmptyState, LoadingState } from './states';

const PendingInvitationsList = ({
  isLoading,
  isError,
  invitations,
  onInvitationAccepted,
  onInvitationDeclined,
  shouldFetchDeclinedInvitations,
  onShowDeclinedInvitationsToggleChanged,
}) => (
  <div>
    <Checkbox
      toggle
      checked={shouldFetchDeclinedInvitations}
      label="Show declined invitations"
      onClick={onShowDeclinedInvitationsToggleChanged}
    />
    <Divider hidden clearing />
    <Card.Group fluid itemsPerRow="three">
      {
        isLoading && <LoadingState />
      }
      {
        !isLoading && !isError && _.isEmpty(invitations) &&
        <EmptyState />
      }
      {
        !isLoading && !isError && _.map(invitations, invitation => (
          <PendingInvitation
            {...invitation}
            onInvitationAccepted={onInvitationAccepted}
            onInvitationDeclined={onInvitationDeclined}
          />
        ))
      }
    </Card.Group>
  </div>

);

PendingInvitationsList.propTypes = {
  isLoading: PropTypes.bool.isRequired,
  isError: PropTypes.bool.isRequired,
  shouldFetchDeclinedInvitations: PropTypes.bool.isRequired,
  invitations: PropTypes.array.isRequired,
  onInvitationAccepted: PropTypes.func.isRequired,
  onInvitationDeclined: PropTypes.func.isRequired,
  onShowDeclinedInvitationsToggleChanged: PropTypes.func.isRequired,
};

export default PendingInvitationsList;



/** WEBPACK FOOTER **
 ** ./src/components/pending-invitations-list/index.js
 **/